export default __webpack_public_path__ + "static/Ashley_PhotoMontage-89b632f64547d9ada4e981c30eeb4fbb.jpg";